import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, Stack, TextField } from '@mui/material';
import { MuiFileUploader } from 'common/ui/file-uploader/MuiFileUploader';
import { useController, useForm } from 'react-hook-form';
import {
  ProductBannerAsset,
  ProductId,
} from 'store/api/pages-api/pages-api-types';

import { styles } from './product-banner-creator.styles';

type Props = {
  currentProductId: ProductId;
  onAddButton?: (data: ProductBannerAsset) => void;
  onDeleteButton?: () => void;
};

const ProductBannerCreator = ({ currentProductId, onAddButton }: Props) => {
  const { control, handleSubmit, setValue } = useForm<ProductBannerAsset>({
    defaultValues: {
      assets_type: 'assets',
      file_data: { type: 'banner' },
      type: 'added',
    },
  });

  const fileField = useController({
    control,
    name: 'file',
    rules: { required: 'Field is required' },
  });
  const titleField = useController({ control, name: 'file_data.title' });
  const textField = useController({ control, name: 'file_data.text' });

  const clearForm = () => {
    setValue('file_data.text', '');
    setValue('file_data.title', '');
    setValue('file', null);
    setValue('product_id', '');
    setValue('preview', null);
  };

  const onSubmit = (data: ProductBannerAsset) => {
    data.product_id = currentProductId;

    if (onAddButton) onAddButton(data);

    clearForm();
  };

  return (
    <Stack spacing={1.5} sx={styles.stack}>
        <Box sx={styles.fileUploaderWrapper}>
          <MuiFileUploader
            error={fileField.fieldState.error?.message}
            format={['image/jpeg', 'image/png', 'image/svg', 'image/jpg']}
            onChange={(file, preview) => {
              fileField.field.onChange(file);
              setValue('preview', preview);
            }}
            value={fileField.field.value}
          />
        </Box>

        <TextField
          fullWidth
          label="Title"
          placeholder="Enter title"
          size="small"
          {...titleField.field}
          error={titleField.fieldState.invalid}
          helperText={titleField.fieldState.error?.message}
        />

        <TextField
          fullWidth
          label="Text"
          multiline
          placeholder="Enter your simple wording"
          size="small"
          sx={styles.textField}
          {...textField.field}
          error={textField.fieldState.invalid}
          helperText={textField.fieldState.error?.message}
        />

        <Box sx={styles.actions}>
          <Button
            onClick={handleSubmit(onSubmit)}
            size="small"
            startIcon={<AddIcon />}
            type="button"
            variant="contained"
          >
            Add
          </Button>
          <Button
            color="inherit"
            onClick={clearForm}
            size="small"
            startIcon={<ClearIcon />}
            type="button"
            variant="outlined"
          >
            Clear
          </Button>
        </Box>
      </Stack>
  );
};

export { ProductBannerCreator };
